import { render, staticRenderFns } from "./FormInputGroupSizing.vue?vue&type=template&id=bb8cb98c&"
import script from "./FormInputGroupSizing.vue?vue&type=script&lang=js&"
export * from "./FormInputGroupSizing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports